export default __webpack_public_path__ + "static/media/decor6.b1aee871.webp";